export const isStringifiedJSON = (value: any) => {
  if (typeof value !== 'string') return false;

  try {
    const parsed = JSON.parse(value);
    // Check if the parsed result is a valid object or array
    return typeof parsed === 'object' && parsed !== null;
  } catch (e) {
    return false;
  }
};

export const handleError = (error: any, message: string) => {
  const err = error instanceof Error ? error : new Error(String(error));
  // console.error(message, {
  //   name: err.name,
  //   message: err.message,
  //   error: err,
  //   // stack: err.stack,
  // });
};

/**
 * @param backgroundColor - The background color to check
 * @returns true if the text color should be black, false otherwise
 */
export const shouldTextBeBlack = (backgroundColor: string) => {
  if (!backgroundColor) return true;
  const luminence = computeLuminence(backgroundColor);
  // Contrast ratio against white (#ffffff) and near-black (#101010)
  const contrastWhite = 1.05 / (luminence + 0.05);
  const contrastBlack = (luminence + 0.05) / (0.05 + Math.pow(16 / 255, 2.4)); // ~0.0022
  // Multiply contrastBlack by 2 to favor white text
  return contrastBlack > contrastWhite * 2;
};
const computeLuminence = (backgroundColor: string) => {
  var colors = hexToRgb(backgroundColor);

  if (!colors) {
    throw new Error('Invalid color');
  }

  var components = ['r', 'g', 'b'];
  for (var i in components) {
    var c = components[i];

    colors[c] = colors[c] / 255.0;

    if (colors[c] <= 0.03928) {
      colors[c] = colors[c] / 12.92;
    } else {
      colors[c] = Math.pow((colors[c] + 0.055) / 1.055, 2.4);
    }
  }

  var luminence = 0.2126 * colors.r + 0.7152 * colors.g + 0.0722 * colors.b;

  return luminence;
};

const hexToRgb = (hex: string): Record<string, number> | null => {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
};

export const changeColorOpacity = (color: string, opacity: number) => {
  const rgb = hexToRgb(color);
  return `rgba(${rgb?.r}, ${rgb?.g}, ${rgb?.b}, ${opacity})`;
};

const VOWELS = new Set(['a', 'e', 'i', 'o', 'u']);

export const pluralize = (word: string, count: number) => {
  if (count === 1) return word;

  const last = word.slice(-1);
  const secondLast = word.slice(-2, -1);

  // Consonant + y → ies (e.g. Pharmacy → Pharmacies, Category → Categories)
  if (
    last === 'y' &&
    word.length >= 2 &&
    !VOWELS.has(secondLast.toLowerCase())
  ) {
    return word.slice(0, -1) + 'ies';
  }

  // s, x, z, ch, sh → add es
  if (
    word.endsWith('ch') ||
    word.endsWith('sh') ||
    last === 's' ||
    last === 'x' ||
    last === 'z'
  ) {
    return word + 'es';
  }

  return word + 's';
};

export const roundToDecimalPlaces = (value: number, decimalPlaces?: number) => {
  return (
    Math.round(value * 10 ** (decimalPlaces || 1)) / 10 ** (decimalPlaces || 1)
  );
};
